import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../../../core/abstracts/baseComponent';
import { QueuesService } from '../../../../core/services/queues.service';

@Component({
  selector: 'app-insurance-changes-link',
  template: '<button type="button" routerLink="/queues/insurance-changes" class="btn btn-secondary mr-2">Insurance Changes <span *ngIf="count > 0" class="badge badge-danger">{{count}}</span></button>',
  standalone: false
})
export class InsuranceChangesLinkComponent extends BaseComponent implements OnInit {
  count = 0;
  constructor(private queues: QueuesService) { super(); }
  ngOnInit(): void {
    this.subs.push(this.queues.getInsuranceChangeCount().subscribe({ next: count => this.count = count, error: () => this.count = 0 }));
  }
}
